import React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../Store';
import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';
import { getCMSObject } from 'sg-ui-components';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import ProgressiveJackpot from '../Components/ProgressiveJackpot';

const PromotionsPage = ({ user, config, cmsSourceFirebase, actions, promotions, loading }) => {
    const page = {
        title: getCMSObject('data.microsite.general.promotions.pageInfo.pageTitle'),
        className: 'promotions',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>
            <div className='promo-container'>
                {loading.actions['getPromotions'] ? (
                    <div className='loading-icon ellipses' />
                ) : (
                    promotions?.promotions?.map(({ id, title, status, directory, images, entries, hasJackpot = false }, idx) => {
                        let imgPath = idx > 2 ? images.small : images.large;

                        return (
                            <div key={id} className={`promo-info ${idx > 2 ? 'sm' : ''}`}>
                                <div className='promo-banner'>
                                    {hasJackpot && (
                                        <div className='progressive-jackpot-container'>
                                            <ProgressiveJackpot />
                                        </div>
                                    )}
                                    <Link to={`promotion/${directory}`}>
                                        <img src={imgPath} alt={title} className='desktop' />
                                        <img src={images.small} alt={title} className='mobile' />
                                    </Link>
                                </div>
                                <div className='promo-title-entries'>
                                    <h3 className='promo-title'>{title}</h3>
                                    {status.toLowerCase() === 'active' ? (
                                        user.loggedIn ? (
                                            <h3 className='promo-title'>Next Draw: {Number(entries)} Entries</h3>
                                        ) : (
                                            <h3 className='promo-title login'>
                                                <Link to='/login'>LOG IN</Link>&nbsp;TO VIEW ENTRIES
                                            </h3>
                                        )
                                    ) : (
                                        <h3 className='promo-status closed'>Closed</h3>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionsPage);
